import { render } from "./collegeStudents.vue?vue&type=template&id=46329c20&scoped=true"
import script from "./collegeStudents.vue?vue&type=script&lang=js"
export * from "./collegeStudents.vue?vue&type=script&lang=js"

import "./collegeStudents.vue?vue&type=style&index=0&id=46329c20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46329c20"]])

export default __exports__